import { useLayoutEffect, useRef } from 'react';

export default function usePosSizingDraftConsumer({
    activeView,
    optimizerViewMode = 'normal',
    workspaceAvailable = true,
    posSizingLoading,
    posSizingLoaded,
    fetchPosSizingData,
    watchlistVersion = 0,
    posSizingSaving = false,
    posSizingPendingChangesRef,
    posSizingEditingRef,
}) {
    const requestedWatchlistVersionRef = useRef(watchlistVersion);
    // Hydrate eagerly for the Position Sizing workspace and on demand when the
    // user explicitly chooses the Position Sizing baseline in Optimizer.
    // A cold Optimizer entry defaults to Current and must not trigger this load.
    useLayoutEffect(() => {
        const needsPosSizingDraft = activeView === 'pos-sizing'
            || (activeView === 'optimizer' && optimizerViewMode === 'pos-sizing');
        if (
            workspaceAvailable !== true
            || !needsPosSizingDraft
            || posSizingLoading
            || posSizingSaving
            || posSizingPendingChangesRef?.current
            || posSizingEditingRef?.current
            || (posSizingLoaded && requestedWatchlistVersionRef.current === watchlistVersion)
        ) return;

        // The saved draft keeps its pinned inputs, but its publication base must
        // acknowledge the active Watchlist revision before the next edit.
        // Record the attempt so a blocked response does not create a retry loop.
        requestedWatchlistVersionRef.current = watchlistVersion;
        void fetchPosSizingData({ persistPortfolio: false }).catch((error) => {
            console.error('Error loading Pos Sizing draft:', error);
        });
    }, [
        activeView,
        fetchPosSizingData,
        optimizerViewMode,
        posSizingLoaded,
        posSizingLoading,
        posSizingSaving,
        posSizingPendingChangesRef,
        posSizingEditingRef,
        watchlistVersion,
        workspaceAvailable,
    ]);
}
